import { ADD_TO_CART, ADD_TO_CART_BULK, GET_ALL_CART_DATA } from "./actionTypes";
import { toast } from "react-toastify";
import { get, post } from "../../_services/apiService";
import { API_URL } from "../../_services/apiUrl";
import { decryptData } from "../../_services/encDnc";

export const get_cart_Data = () => async (dispatch) => {
    const loginId = localStorage.getItem('loginId');

    if (loginId) {
        try {
            const response = await get(`${API_URL.GetCartDetailByLoginId}?pLoginId=${loginId}`);

            if (response.isSuccess === 200) {
                dispatch({ type: GET_ALL_CART_DATA, payload: response.data });
            } else {
                dispatch({ type: GET_ALL_CART_DATA, payload: [] });
            }
        } catch (error) {
            dispatch({ type: GET_ALL_CART_DATA, payload: [] });
        }
    } else {
        const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
        dispatch({ type: GET_ALL_CART_DATA, payload: localCartData });
    }
};

const GetProductDetailById = async (productId) => {

    try {
        const response = await get(API_URL.GetProductDetailById, {
            pProductDetailId: productId
        });

        if (response.isSuccess === 200) {
            const encryptedData = response.data;
            const result = decryptData(encryptedData);

            if (result) {
                return result[0];
            } else {
                return [];
            }
        } else {
            return [];
        }
    } catch (error) {
        toast.error('Please try again later.');
    }
};

export const addToCart = (formData, quantity) => async (dispatch) => {
    const loginId = localStorage.getItem('loginId');
    if (loginId) {
        try {

            const response = await post(API_URL?.SaveCartDetail, formData);
            if (response.isSuccess === 200) {
                dispatch({ type: ADD_TO_CART, payload: response.data });
                toast.success("Add item in cart Successful!");
            } else {
                toast.error("Failed to add item to cart");
            }
        } catch (error) {
            toast.error("An error occurred. Please try again.");
        }
    } else {
        try {
            const productDetails = await GetProductDetailById(formData.productId);
            const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
            const existingItem = localCartData.find(item => item.productId === productDetails.productId);
            const colorTypeName = localStorage.getItem('colorTypeName') ||
                (productDetails?.productSkuDtos?.[0]?.colorName || null);

            const sizeTypeName = localStorage.getItem('sizeTypeName') ||
                (productDetails?.productSkuDtos?.[0]?.sizeTypeName || null);

            const skuId = localStorage.getItem('skuId') ||
                (productDetails?.productSkuDtos?.[0]?.skuId || null);

            if (existingItem) {
                existingItem.quantity += quantity;
                existingItem.colorTypeName = colorTypeName;
                existingItem.sizeTypeName = sizeTypeName;
            } else {
                localCartData.push({ ...productDetails, quantity: 1, colorTypeName: colorTypeName, sizeTypeName: sizeTypeName, skuId: skuId });
            }

            localStorage.setItem('cart', JSON.stringify(localCartData));
            dispatch({ type: ADD_TO_CART, payload: { ...productDetails, quantity: 1, colorTypeName: colorTypeName, sizeTypeName: sizeTypeName, skuId: skuId } });
        } catch (error) {
            toast.error("Error occurred while fetching product details.");
        }
    }
};

export const syncCartAfterLogin = () => async (dispatch) => {
    const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
    const loginId = localStorage.getItem('loginId');
    if (loginId && localCartData.length > 0) {
        try {
            const items = localCartData.map(item => ({
                skuId: item?.skuId || (item?.productSkuDtos?.length > 0 ? item.productSkuDtos[0]?.skuId : null),
                cartItemId: 0,
                productId: item.productId,
                loginId: Number(loginId),
                buyStatus: 1,
                quantity: item.quantity,
                unitPrice: item.unitPrice,
                totalAmount: item.unitPrice,
                isActive: true,
                createdBy: 0,
                taxId: item.taxId || 0,
                taxAmount: item.taxAmount || 0
            }));

            const response = await post(API_URL?.SaveBulkCart, items);

            if (response.isSuccess === 200) {
                dispatch({ type: ADD_TO_CART_BULK, payload: response.data });
                localStorage.removeItem('cart');
            } else {
                dispatch({ type: ADD_TO_CART_BULK, payload: [] });
            }
        } catch (error) {
            dispatch({ type: ADD_TO_CART_BULK, payload: [] });
        }
    } else {
    }
};

export const incrQuantity = (item) => async (dispatch) => {
    const loginId = localStorage.getItem('loginId');

    if (loginId) {
        const formData = {
            skuId: item?.skuId,
            productId: item.productId,
            loginId: loginId,
            buyStatus: 0,
            quantity: item.quantity + 1,
            isActive: true,
            createdBy: 0
        };

        try {
            const response = await post(API_URL?.SaveCartDetail, formData);
            if (response.isSuccess === 200) {
                dispatch(get_cart_Data());
            }
        } catch (error) {

        }
    } else {
        const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
        const existingItem = localCartData.find(cartItem => cartItem.productId === item.productId);

        if (existingItem) {
            existingItem.quantity += 1;
        } else {
            localCartData.push({ ...item, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(localCartData));
        dispatch(get_cart_Data());
    }
};

export const decrQuantity = (item) => async (dispatch, getState) => {
    const loginId = localStorage.getItem('loginId');
    if (loginId) {
        const formData = {
            skuId: item?.skuId,
            productId: item.productId,
            loginId: loginId,
            buyStatus: 0,
            quantity: item.quantity - 1,
            isActive: true,
            createdBy: 0
        };

        if (formData.quantity === 0 || formData.quantity === null) {
            dispatch(deleteItem(item));
            return;
        }

        try {
            const response = await post(API_URL?.SaveCartDetail, formData);
            if (response.isSuccess === 200) {
                dispatch(get_cart_Data());
            }
        } catch (error) {

        }
    } else {
        const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
        const existingItem = localCartData.find(cartItem => cartItem.productId === item.productId);

        if (existingItem) {
            existingItem.quantity -= 1;
        }
        else {
            localCartData.push({ ...item, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(localCartData));
        dispatch(get_cart_Data());
    }
};

export const deleteItem = (item) => async (dispatch) => {
    const loginId = localStorage.getItem('loginId');
    if (loginId) {
        try {
            const response = await get(API_URL?.DeleteCartDetailByLoginId, {
                pCartDetailId: item?.cartItemId,
                LoginId: loginId
            });

            if (response.isSuccess === 200) {
                dispatch(get_cart_Data());
            } else {
                toast.error("Failed to delete item");
            }
        } catch (error) {

        }
    } else {
        const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
        const updatedCartData = localCartData.filter(cartItem => cartItem.productId !== item.productId);

        localStorage.setItem('cart', JSON.stringify(updatedCartData));
        dispatch(get_cart_Data());
    }
};

export const buyNow = (formData) => async (dispatch) => {
    const loginId = localStorage.getItem('loginId');
    const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];
    const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

    if (existingItemDetails.length > 0 || existingCartItemDetails.length > 0) {
        localStorage.removeItem('cartItemDetail');
        localStorage.removeItem('itemDetail');
    }

    if (loginId) {
        try {
            const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];

            // Add the new formData to the existing array
            existingItemDetails.push(formData);

            // Store the updated array back into localStorage
            localStorage.setItem('itemDetail', JSON.stringify(existingItemDetails));

        } catch (error) {
            toast.error("An error occurred. Please try again.");
        }
    } else {
        const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];

        // Add the new formData to the existing array
        existingItemDetails.push(formData);

        // Store the updated array back into localStorage
        localStorage.setItem('itemDetail', JSON.stringify(existingItemDetails));
    }
};

export const cartCheckout = (formData) => () => {
    const loginId = localStorage.getItem('loginId');
    const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];
    const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

    if (existingItemDetails.length > 0 || existingCartItemDetails.length > 0) {
        localStorage.removeItem('cartItemDetail');
        localStorage.removeItem('itemDetail');
    }

    if (loginId) {
        try {
            const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

            const filteredData = formData.filter(item => item.buyStatus === 1);

            // Add the new formData to the existing array
            existingCartItemDetails.push(...filteredData);

            // Store the updated array back into localStorage
            localStorage.setItem('cartItemDetail', JSON.stringify(existingCartItemDetails));

        } catch (error) {
            toast.error("An error occurred. Please try again.");
        }
    }
}

export const productReorder = (formData) => () => {
    const loginId = localStorage.getItem('loginId');
    const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];
    const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

    if (existingItemDetails.length > 0 || existingCartItemDetails.length > 0) {
        localStorage.removeItem('cartItemDetail');
        localStorage.removeItem('itemDetail');
    }

    if (loginId) {
        try {
            const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

            const filteredData = formData.filter(item => item.buyStatus === 1);

            // Add the new formData to the existing array
            existingCartItemDetails.push(...filteredData);

            // Store the updated array back into localStorage
            localStorage.setItem('cartItemDetail', JSON.stringify(existingCartItemDetails));

        } catch (error) {
            toast.error("An error occurred. Please try again.");
        }
    }
}